var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.114 23.058C18.0997 23.1803 18.0408 23.2931 17.9485 23.3746C17.8563 23.4562 17.7372 23.5008 17.614 23.5H9.382C9.25886 23.5008 9.13974 23.4562 9.04747 23.3746C8.95521 23.2931 8.89629 23.1803 8.882 23.058L7 7.05801C6.99179 6.98765 6.99861 6.91634 7.02003 6.84882C7.04145 6.78129 7.07698 6.71909 7.12425 6.66633C7.17153 6.61357 7.22947 6.57146 7.29425 6.54279C7.35903 6.51411 7.42916 6.49953 7.5 6.50001H19.5C19.5708 6.49953 19.641 6.51411 19.7058 6.54279C19.7705 6.57146 19.8285 6.61357 19.8758 6.66633C19.923 6.71909 19.9586 6.78129 19.98 6.84882C20.0014 6.91634 20.0082 6.98765 20 7.05801L18.114 23.058Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 21.5L9.75 3.113C9.68116 2.39808 9.34858 1.73441 8.81707 1.25134C8.28557 0.768269 7.59323 0.500421 6.875 0.5H4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.438 10.5H19.592"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.408 10.5H10.453"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M16.265 1C16.1269 1 16.015 0.888071 16.015 0.75C16.015 0.611929 16.1269 0.5 16.265 0.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M16.265 1C16.4031 1 16.515 0.888071 16.515 0.75C16.515 0.611929 16.4031 0.5 16.265 0.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.75 3.5C13.6119 3.5 13.5 3.38807 13.5 3.25C13.5 3.11193 13.6119 3 13.75 3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.75 3.5C13.8881 3.5 14 3.38807 14 3.25C14 3.11193 13.8881 3 13.75 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M17.25 4.5C17.1119 4.5 17 4.38807 17 4.25C17 4.11193 17.1119 4 17.25 4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M17.25 4.5C17.3881 4.5 17.5 4.38807 17.5 4.25C17.5 4.11193 17.3881 4 17.25 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M15.765 13C15.6269 13 15.515 12.8881 15.515 12.75C15.515 12.6119 15.6269 12.5 15.765 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M15.765 13C15.9031 13 16.015 12.8881 16.015 12.75C16.015 12.6119 15.9031 12.5 15.765 12.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.75 16C13.6119 16 13.5 15.8881 13.5 15.75C13.5 15.6119 13.6119 15.5 13.75 15.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.75 16C13.8881 16 14 15.8881 14 15.75C14 15.6119 13.8881 15.5 13.75 15.5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M15.265 19.5C15.1269 19.5 15.015 19.3881 15.015 19.25C15.015 19.1119 15.1269 19 15.265 19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M15.265 19.5C15.4031 19.5 15.515 19.3881 15.515 19.25C15.515 19.1119 15.4031 19 15.265 19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.9c4f9b0d21bbc8aa08588feb659fa360.svg";
export { ForwardRef as ReactComponent };